var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"credentials-with-async-fallback"},[_vm._t("credentials")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }